import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { MAIN_ROUTES } from './routes/routes';
// app.routes.ts
export const routes: Routes = [
  { path: '', component: LoginComponent },

  {
    path: 'home',
    loadComponent: () =>
      import('./components/landing/landing.component').then((m) => m.LandingComponent),
    children: MAIN_ROUTES,
  },
  { path: 'login/:token', component: LoginComponent },
  { path: 'refresh-token/:token', component: LoginComponent },
];
